import * as React from 'react';
import { cn } from '@lib/utils';

interface NotificationBadgeProps {
  count: number;
  className?: string;
}

/**
 * Floating count badge for pending items (matches Messages tab badge style).
 * Renders nothing when count is 0.
 */
export const NotificationBadge: React.FC<NotificationBadgeProps> = ({ count, className }) => {
  if (count <= 0) return null;

  return (
    <span
      className={cn(
        'flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[9px] font-semibold text-destructive-foreground',
        className,
      )}
      role="status"
      aria-label={`${count} pending request${count !== 1 ? 's' : ''}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};
